import { IUserData } from 'src/app/shared/interfaces/user.interface';
import { GlobalStorage } from '../globals.service';
import jwt_decode from 'jwt-decode';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JWTService {
  constructor(public globalSvc: GlobalStorage) {}

  public getUserDataFromToken = () => {
    try {
      const token = this.globalSvc;
      const decodedToken: any = jwt_decode(token.token);
      const user: IUserData = {
        name: decodedToken.name,
        lastName: decodedToken.lastName,
        rut: decodedToken.user_id,
        email: decodedToken.email,
      };
      return user;
    } catch (error) {
      console.error('Error getting user data from token');
      console.log(error);
      const user: IUserData = {
        name: '',
        lastName: '',
        rut: '',
        email: '',
      };
      return user;
    }
  };
}
